import { ESdChangeReason, IScreenFolder } from "@kuika/kuika-cl-model";
import { IWithSDProps, withSD } from "../../../../shared/hoc/screen-design-consumer";
import { PureSdComponent } from "../../../../shared/pure-sd";
import { getSdInstance } from "../../../../shared/utility/designer-context";
import {
  createDesignerFolder,
  createDesignerSubfolder,
  renameDesignerFolder,
  renameDesignerSubfolder
} from "../../../../shared/utility/designer-folder-actions";
import { KMainFunctions } from "../../../../shared/utility/main-functions";
import FolderModal from "../../../common/folder-modal";

export interface IScreenFolderAddState {
  formData: IScreenFolder;
}

export interface IScreenFolderAddProps {
  showModal?: boolean;
  closeModal?: () => void;
  showEditModal?: boolean;
  closeEditModal?: () => void;
  editingFolderId?: string;
  editingFolderName?: string;
  projectId: string;
  componentSetId: string;
  folderParentFolderId?: string | undefined | null;
}

class ScreenFolderAddComponent extends PureSdComponent<IScreenFolderAddProps & IWithSDProps, IScreenFolderAddState> {
  constructor(props: IScreenFolderAddProps & IWithSDProps) {
    super(props);
    const folders = {} as IScreenFolder;
    this.state = {
      formData: folders
    };
  }

  private checkFolderNameExists = (
    name: string,
    folders: IScreenFolder[] = this.props.sd.project.screenFolders || []
  ): boolean => {
    return folders.some((folder) => {
      if (folder.name?.toLowerCase() === name?.toLowerCase()) {
        return true;
      }
      if (folder.children && folder.children.length > 0) {
        return this.checkFolderNameExists(name, folder.children);
      }
      return false;
    });
  };

  onSubmit = async (data: { name: string }): Promise<boolean> => {
    try {
      if (this.props.showEditModal) {
        return this.handleEditFolder(data);
      }
      return this.handleAddFolder(data);
    } catch (error) {
      KMainFunctions.exceptionHandler(error);
      return false;
    }
  };

  handleAddFolder = (data: { name: string }): boolean => {
    if (this.checkFolderNameExists(data.name)) {
      KMainFunctions.displayWarningNotification("This folder name already exists.");
      return false;
    }
    if (!this.props.folderParentFolderId) {
      createDesignerFolder(getSdInstance(), { folderType: "screen", folderName: data.name });
    } else {
      this.handleAddFolderInFolder(data);
    }
    return true;
  };

  handleEditFolder = (data: { name: string }): boolean => {
    if (
      data.name?.toLowerCase() !== this.props.editingFolderName?.toLowerCase() &&
      this.checkFolderNameExists(data.name)
    ) {
      KMainFunctions.displayWarningNotification("This folder name already exists.");
      return false;
    }

    if (this.props.editingFolderId) {
      if (!this.props.folderParentFolderId) {
        renameDesignerFolder(getSdInstance(), {
          folderType: "screen",
          folderId: this.props.editingFolderId,
          folderName: data.name
        });
      } else {
        this.handleEditFolderInFolder(data);
      }
      return true;
    }
    return false;
  };

  handleAddFolderInFolder = (data: { name: string }) => {
    if (this.props.folderParentFolderId) {
      createDesignerSubfolder(getSdInstance(), {
        folderType: "screen",
        parentFolderId: this.props.folderParentFolderId,
        folderName: data.name
      });
    }
  };

  handleEditFolderInFolder = (data: { name: string }) => {
    if (this.props.editingFolderId) {
      const parentFolderId = this.props.folderParentFolderId;
      if (parentFolderId) {
        renameDesignerSubfolder(getSdInstance(), {
          folderType: "screen",
          parentFolderId,
          subFolderId: this.props.editingFolderId,
          folderName: data.name
        });
      }
    }
  };

  render() {
    return (
      <FolderModal
        showModal={this.props.showModal}
        closeModal={this.props.closeModal}
        showEditModal={this.props.showEditModal}
        closeEditModal={this.props.closeEditModal}
        editingFolderId={this.props.editingFolderId}
        editingFolderName={this.props.editingFolderName}
        onSubmit={this.onSubmit}
        checkFolderNameExists={this.checkFolderNameExists}
        folderType="screen"
      />
    );
  }

  checkNeedRender = (changeReason: ESdChangeReason): boolean => {
    return false;
  };
}

const screenFolderAddComponent = withSD<IScreenFolderAddProps>(ScreenFolderAddComponent);
export { screenFolderAddComponent as ScreenFolderAddComponent };
